<template>
  <v-row class="py-2">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="60%"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="text-none text-white"
          color="primary"
          depressed
          rounded
          small
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            dark
            left
          >
            mdi-plus
          </v-icon>
          Adicionar
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Adicionar produto</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="cancelar"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <base-loading v-if="loading" />
        <v-form
          v-else
          ref="form"
          dense
          lazy-validation
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    ref="categoriaProdutoSelect"
                    v-model="form.categoria_id"
                    :items="categories"
                    item-text="nome"
                    item-value="id"
                    class="d-flex justify-space-between"
                    label="Categoria do Produto *"
                    :rules="[rules.required]"
                    clearable
                    dense
                    autocomplete="nope"
                    outlined
                    rounded
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="form.produto_id"
                    :items="produtosDisponiveis(form.categoria_id)"
                    :filter="filterProduto"
                    item-text="nome"
                    item-value="id"
                    item-disabled="disabled"
                    class="d-flex justify-space-between"
                    label="Produto *"
                    clearable
                    dense
                    autocomplete="nope"
                    outlined
                    rounded
                    required
                    :rules="[rules.required]"
                    :disabled="produtos.length === 0"
                    @change="selectProduto"
                  >
                    <template v-slot:item="{ item }">
                      <span>{{ item.codigo + ' - ' + item.nome }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.quantidade"
                    dense
                    label="Quantidade *"
                    outlined
                    :rules="[rules.required, rules.geq(1)]"
                    required
                    type="number"
                    rounded
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <base-vuetify-money
                    v-model="form.valor_unitario"
                    :options="money"
                    :rules="[rules.required, validateMenor]"
                    maxlength="10"
                    label="Valor unitario (R$) *"
                    validate-on-blur
                    dense
                    outlined
                    rounded
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="form.observacao"
                    maxlength="255"
                    height="65"
                    dense
                    label="Observação"
                    outlined
                    rounded
                  />
                </v-col>
              </v-row>
            </v-container>
            <small>*indica campo obrigatório</small>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-none"
            color="red darken-1 white--text"
            rounded
            @click="cancelar"
          >
            <v-icon
              dark
              left
            >
              mdi-minus-circle
            </v-icon>
            Fechar
          </v-btn>
          <v-btn
            class="text-none"
            color="green darken-1 white--text"
            rounded
            @click="submitForm"
          >
            <v-icon
              left
              dark
            >
              mdi-plus-circle
            </v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { BOOTSTRAP_PROFILE, CLOSE, SUBMIT, LOAD_UNIDADES } from '../../store/modules/forms/atendimento'
  import rules from '../../utils/formRules'
  export default {
    name: 'AtendimentoItemDialog',

    emits: ['input', 'submit'],

    props: {
      value: {
        type: Boolean,
        default: false,
      },

      cotacaoId: {
        type: String,
        default: '',
      },

      itensSelected: {
        type: Array,
        default: () => [],
      },

      tabela: {
        type: Number,
        default: null,
      },

      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      dialog: false,

      money: {
        locale: 'pt-BR',
        precision: 2,
      },
      rules,
      produto_unidade_negocio: null,
      form: {
        produto_id: '',
        categoria_id: '',
        observacao: '',
        quantidade: '',
        valor_unitario: 0,
        valor_subtotal: 0,
        valor_desconto: 0,
        codProduto: '',
        volume: 0,
      },
    }),

    computed: {
      ...mapState('form/atendimento', ['produtos', 'produtosUnidades', 'categories', 'unidades', 'loading']),
    },

    watch: {
      value: {
        immediate: true,
        handler (value) {
          this.dialog = value
        },
      },

      dialog (value) {
        this.$emit('input', value)
      },
    },

    created () {
    },

    methods: {
      ...mapMutations('form/atendimento', [CLOSE]),
      ...mapActions('form/atendimento', [BOOTSTRAP_PROFILE, SUBMIT, LOAD_UNIDADES]),
      adicionar () {
        this.dialog = true
      },
      filterProduto (item, consulta, nome) {
        if (nome.toLowerCase().includes(consulta.toLowerCase())) return true
        if (item.codigo.includes(consulta)) return true
        return false
      },

      cancel () {
        this.CLOSE()
      },

      produtosDisponiveis (nCategoria) {
        const result = this.produtos.filter((el) => {
          return el.categoria.id === nCategoria
        })
        return result.filter((el) => {
          if (this.itensSelected.some((item) => item.produto_id === el.id)) {
            return false
          }
          return this.produtosUnidades.some(item => item.produto_id === el.id)
        })
      },

      submitForm () {
        if (!this.$refs.form.validate()) {
          return null
        }
        const produto = this.produtos.find(el => el.id === this.form.produto_id)

        if (!this.produto_unidade_negocio) {
          window.Toast.fire('Atenção', 'Produto não disponível para esta unidade de negócio', 'warning')
          return null
        }
        const produto_unidade_negocio_id = this.produto_unidade_negocio.id

        this.form.nome_produto = produto.nome
        this.form.unidade_medida = produto.unidade.nome
        this.form.valor_subtotal = this.form.quantidade * this.form.valor_unitario
        this.form.valor_desconto = 0
        this.form.valor_total = this.form.valor_subtotal - this.form.valor_desconto
        this.form.nome_categoria = produto.categoria.nome
        this.form.produto_unidade_negocio_id = produto_unidade_negocio_id
        this.form.produto_id = produto.id
        this.form.codProduto = produto.codigo
        this.form.volume = produto.volume * this.form.quantidade
        // this.form.valor_unitario = String(this.form.valor_unitario.toFixed(2))
        this.$emit('submit', this.form)
        this.limparCampos()
      },

      cancelar () {
        this.form = {
          produto_id: '',
          categoria_id: '',
          observacao: '',
          quantidade: '',
          valor_unitario_referencial: '',
          valor_unitario: '',
          valor_subtotal: '',
          valor_total: '',
          atendimento_id: '',
          margem_lucro: 0,
          icms: 0,
          fornecedor_id: '',
          valor_unit_frete: null,
          codProduto: '',
          volume: 0,
        }
        this.dialog = false
      },
      filterItem (item, consulta, nome) {
        if (nome.toLowerCase().includes(consulta.toLowerCase())) return true
        if (item.identificador.includes(consulta)) return true
        if (item.complemento && item.complemento.toLowerCase().includes(consulta.toLowerCase())) return true
        return false
      },

      validateMenor (valor) {
        if (!valor) return 'campo obrigatório'
        const valorFormat = parseFloat((valor.replace('.', '')).replace(',', '.'))
        if (valorFormat <= 0) return 'valor deve ser maior que 0'
        return true
      },
      selectProduto (value) {
        if (!value) {
          this.produto_unidade_negocio = null
          return
        }
        this.produto_unidade_negocio = this.produtosUnidades.find(el => el.produto_id === value)
        if (!this.produto_unidade_negocio) {
          window.Toast.fire('Atenção', 'Produto não disponível para esta unidade de negócio', 'warning')
          return
        }
        if (this.tabela) {
          const valor_unitario = this.produto_unidade_negocio[`preco${this.tabela}`] || '0'
          this.form.valor_unitario = valor_unitario
        }
      },
      limparCampos () {
        this.form = {
          produto_id: '',
          categoria_id: '',
          observacao: '',
          quantidade: '',
          valor_unitario_referencial: '',
          valor_unitario: '',
          valor_subtotal: '',
          valor_total: '',
          atendimento_id: '',
          margem_lucro: 0,
          icms: 0,
          fornecedor_id: '',
          valor_unit_frete: null,
          codProduto: '',
          volume: 0,
        }
        this.$nextTick(() => {
          this.$refs.form.resetValidation()

          const categoriaProdutoSelect = this.$refs.categoriaProdutoSelect
          if (categoriaProdutoSelect && categoriaProdutoSelect.focus) {
            categoriaProdutoSelect.focus()
            categoriaProdutoSelect.activateMenu()
          }
        })
      },
    },
  }
</script>
